import { FloatingTooltipContentText } from '../../Floating'

export function getUserMultiValueContentLinkedTooltip({ t, value }) {
  return (
    <FloatingTooltipContentText
      additionalText={t('UserMultiValue.ClickToOpenTooltipTextKey')}
      text={value}
    />
  )
}
